import { Eraser } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '@/context/FilterContext';

/**
 * Botao "Limpar filtros". Sempre visivel (mesmo sem filtros activos);
 * mostra badge com qtd de filtros activos para que o user perceba o estado
 * mesmo apos re-abrir o browser (filtros persistem em localStorage).
 */
export function ResetButton() {
  const { activeCount, dispatch } = useFilters();
  const { t } = useTranslation();
  const hasActive = activeCount > 0;

  return (
    <button
      type="button"
      className={`aiobi-icon-btn aiobi-reset-btn${hasActive ? ' aiobi-reset-btn--active' : ''}`}
      onClick={() => dispatch({ type: 'RESET' })}
      disabled={!hasActive}
      title={t('filters.reset')}
      aria-label={t('filters.reset')}
    >
      <Eraser size={14} />
      <span>{t('filters.reset')}</span>
      {hasActive && <span className="aiobi-reset-btn__badge">{activeCount}</span>}
    </button>
  );
}
